/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ROLE_MAPPINGS = 'Role Mappings';
export const EMPTY_SCREEN_TITLE = "Role mappings are optional. Configure a role mapping to align your Identity Provider's roles with those specified in the Roles tab (Blue Yonder Roles).";
export const ADD_ROLE_MAPPING = "Add Role Mapping";
export const TITLE = 'accessing Roles';
export const SEARCH_ROLE = 'Search Identity Provider Roles (Min. 3 chars)';
export const IDP_ROLE_MAPPING_DISABLED = "Idp Role Mapping is disabled in Realm Settings.";
export const ENABLE_ROLE_MAPPING_MESSAGE = "Role mappings between your Identity Provider and Blue Yonder are disabled. Any previously configured role mappings will no longer be applied.";
export const NO_ROLE_MAPPING_MESSAGE = "Role mappings are optional. Please request your system administrator to configure a role mapping that associates your Identity Provider's roles with those specified in the Roles tab (Blue Yonder Roles).";
